import BaseEvent from './base/BaseEvent'

function timestamp() {
    return new Date().getTime()
}

// 只对最新请求做响应的类
class TimestampInvoker extends BaseEvent {
    /**
     * 初始化
     * @param {Number} tolerance 时间容差（毫秒）
     */
    constructor(tolerance = 0) {
        super()
        this._tolerance = tolerance
        this._invokPromiseId = null
    }

    async invoke(func) {
        this.off('cancel')
        const _this=this;
        // 进程id
        const _timestamp = timestamp()
        // 当前执行的promiseId
        this._invokPromiseId = _timestamp

        const basePromise = new Promise((resolve, reject) => {
            setTimeout(resolve, _this._tolerance)
        }).then(() => {
            if (_this._invokPromiseId) {
                if (_timestamp === _this._invokPromiseId) {
                    return func()
                }
                throw 'pre-cancel'
            }
            throw 'cancel'
        })
        const rejectPromise = new Promise((resolve, reject) => {
            this.once('cancel', () => reject('cancel'))
        })

        return Promise.race([basePromise, rejectPromise])
    }
    /**
     * @api
     * 取消请求
     */
    cancel() {
        this._invokPromiseId = null
        this.fire('cancel')
    }
}

export const TimestampUtil = {
    getTimestampInvoker(tolerance = 0) {
        return new TimestampInvoker(tolerance)
    }
}
